import apiClient from '../../api/index';
import { ITagsService } from './contracts/tags.service';

const TagsService: ITagsService = {
  async setTag(
    subject: string,
    subjectId: string,
    tagKey: string,
    tagValue: string
  ): Promise<void> {
    await apiClient.request('POST', `/tags/tagger`, {
      subject,
      subjectId,
      tagKey,
      tagValue
    });
  },
  async removeTag(
    subject: string,
    subjectId: string,
    tagKey: string,
    tagValue: string
  ): Promise<void> {
    await apiClient.request('DELETE', `/tags/tagger`, {
      subject,
      subjectId,
      tagKey,
      tagValue
    });
  }
};

export default TagsService;
